/*jshint esversion: 6 */
const url = import.meta.env.VITE_APP_TARIFFS_API_URL;

export let tariffsService = {
    getTranslations: async (locale) => {
        const response = await fetch(
            `${url}api/content-translations/1.0/${locale}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
    availableLocales: async () => {
        const response = await fetch(
            `${url}api/content-translations/1.0/locales/`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
    convertCountryCode: async (alphaCountryCode) => {
        const response = await fetch(
            `${url}api/universe/1.0/countries/${alphaCountryCode}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
    occupationCosts: async (numericCountryCode) => {
        const response = await fetch(
            `${url}api/occupation-costs/1.0/${numericCountryCode}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
    socialSecurityTaxes: async (numericCountryCode, netIncome) => {
        const response = await fetch(
            `${url}api/social-security-taxes/1.0/countries/${numericCountryCode}?net_income=${netIncome}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
};
